import { Box, Icon, Text } from "@storyofams/react-ui";
import Image from "next/image";
import { useRouter } from "next/router";
import { usePostHog } from "posthog-js/react";
import { Checkmark } from "~components/common/Icons";
interface TagsFilterInterface {
  title: string;
  tags: {
    label: string;
    value: string;
    check: boolean;
  }[];
}

const TagsFilterContent: React.FC<TagsFilterInterface> = ({ title, tags }) => {
  const router = useRouter();
  const posthog = usePostHog();
  const tagsHandler = (check: boolean, value: string) => {
    // posthog.capture("Used Filter Recipe Collection");
    if (title === "Niveau" || title === "EWG score") {
      if (check) {
        const route = { query: { ...router.query, difficulty: "" } };
        router.push(route, undefined, { shallow: true });
      } else {
        const route = { query: { ...router.query, difficulty: value } };
        router.push(route, undefined, { shallow: true });
      }
    } else if (title === "Categorieën") {
      if (check) {
        const route = { query: { ...router.query, category: "" } };
        router.push(route, undefined, { shallow: true });
      } else {
        const route = { query: { ...router.query, category: value } };
        router.push(route, undefined, { shallow: true });
      }
    } else {
      if (check) {
        const route = {
          query: {
            ...router.query,
            tags: String(router.query.tags)
              .split(",")
              .filter((item) => item !== value)
              .join(","),
          },
        };
        router.push(route, undefined, { shallow: true });
      } else {
        const route = {
          query: {
            ...router.query,
            tags: router.query.tags ? router.query.tags + `,${value}` : value,
          },
        };
        router.push(route, undefined, { shallow: true });
      }
    }
  };
  return (
    <Box px={2}>
      {tags.map(({ label, value }, index) => {
        const check = JSON.stringify(router.query).includes(value);
        return (
          <Box
            onClick={(e) => {
              tagsHandler(check, value);
              e.stopPropagation();
            }}
            mt="11px"
            display="flex"
            key={label}
            width={"100%"}
            cursor={"pointer"}
          >
            <Box
              width="20px"
              height="20px"
              borderRadius="4px"
              border="1px solid grey200"
              backgroundColor="white"
              mr={"10px"}
              flexShrink={0}
              cursor="pointer"
            >
              {check && (
                <Icon
                  display={check && "none"}
                  icon={Checkmark}
                  fontSize="14px"
                  ml={"2px"}
                />
              )}
            </Box>
            {label.includes("www.ewg.org") ? (
              <Image width={20} height={20} unoptimized src={label} />
            ) : (
              <Text
                overflow="hidden"
                whiteSpace="nowrap"
                fontWeight={400}
                fontSize="16px"
                css={{ textOverflow: "ellipsis", textTransform: "capitalize" }}
              >
                {label}
              </Text>
            )}
          </Box>
        );
      })}
    </Box>
  );
};
export default TagsFilterContent;
